module.exports = __webpack_public_path__ + "img/Avatar-2.c1f91e46.png";